export const getActive = (activeParam: string | null) => {
  if (activeParam === 'true') return 'Только активные';
  if (activeParam === 'false') return 'Только неактивные';
  return '';
};
